var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.81802 0.43934C0.232233 1.02513 0.232233 1.97487 0.81802 2.56066L10.7574 12.5L0.81802 22.4393C0.232233 23.0251 0.232233 23.9749 0.81802 24.5607C1.40381 25.1464 2.35355 25.1464 2.93934 24.5607L15 12.5L2.93934 0.43934C2.35355 -0.146447 1.40381 -0.146447 0.81802 0.43934Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCurrent);
export default __webpack_public_path__ + "static/media/chevron-right-current.256aa8787360732db808b1e6ed4f054a.svg";
export { ForwardRef as ReactComponent };